<template>
    <div>
        <h3 class="font-semibold mb-3">Aperçu application</h3>

        <div class="rounded-2xl shadow bg-white overflow-hidden border">

            <img v-if="image" :src="image" class="w-full h-40 object-cover" />
            <img v-else-if="typeLabel" :src="'/assets/app/'+type+'.png'" class="w-full h-40 object-cover" />

            <div class="p-5">
                <StatusBadge v-if="type" :label="typeLabel" :color="typeClass" />
                
                <h2 class="font-bold text-lg mt-2">
                    {{ title || 'Titre du message' }}
                </h2>

                <p class="text-gray-600 mt-2">
                    {{ message || 'Votre message apparaîtra ici...' }}
                </p>

                <div v-if="actionLabel" :class="'mt-4 px-4 py-1 w-full rounded-full bg-'+typeClass+'-500 text-xs text-center text-white'">
                    {{ actionLabel }} <i class="fa fa-arrow-right ml-2"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatusBadge from '@/Components/StatusBadge'

    export default {
        components: {
            StatusBadge
        },

        props: {
            type: String,
            title: String,
            message: String,
            image: String,
            actionLabel: String
        },

        computed: {
            typeLabel() {
                const labels = {
                    announcement: 'Annonce',
                    information: 'Information',
                    promotion: 'Promotion',
                    warning: 'Avertissement',
                    maintenance: 'Maintenance',
                    update: 'Mise à jour',
                }

                return labels[this.type] || 'sky'
            },

            typeClass() {
                const classes = {
                    announcement: 'sky',
                    information: 'sky',
                    warning: 'orange',
                    promotion: 'yellow',
                    maintenance: 'gray',
                    update: 'greendack',
                }

                return classes[this.type] || classes.information
            }
        }
    }
</script>